<div class="layout" cdk-scrollable>
  <router-outlet />
</div>
